import { useClaims } from "../../modules/generic/hooks/use-claims";
import { usePermissionOverrides } from "./use-permission-overrides";

export interface Permissions {
  ce_admin: boolean;
  super_admin: boolean;
  reviewer: boolean;
}

const defaultPermissions: Permissions = {
  ce_admin: false,
  super_admin: false,
  reviewer: false,
};

export function usePermissions(): Permissions & { isLoading: boolean } {
  const user = useClaims();

  const { overrides } = usePermissionOverrides();

  if (!user) return { ...defaultPermissions, isLoading: true };

  return {
    ce_admin: user["http://changeengine.com/ce_admin"],
    super_admin: user["http://changeengine.com/super_admin"],
    reviewer: user.role === "reviewer",
    isLoading: false,
    ...overrides,
  };
}
